export const objectTypesMap = {
    zone: 'Zones',
    passway: 'Passways',
    floor: 'Floors',
    tenant: 'Tenants',
    place: 'Places',
    location: 'Location',
};
